module.exports = __webpack_public_path__ + "jab/media/pgd.cc0e235e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/pgd.svg
// module id = 1479
// module chunks = 0